class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.formSelector = '#CollectionFiltersForm';
    this.gridSelector = '#ProductsGrid';
    this.activeFiltersSelector = '#active-filters';
    this.loadingSelector = '#loading-indicator';

    this.abortController = null;
    this.defaultInStock = this.hasAttribute('default-in-stock') &&
                          this.getAttribute('default-in-stock') !== 'false';

    // bind once
    this.onChange = this.onChange.bind(this);
    this.onPopState = this.onPopState.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onPriceSubmit = this.onPriceSubmit.bind(this);
  }

  connectedCallback() {
    this.cacheDom();
    this.initEvents();

    if (this.defaultInStock) {
      this.applyDefaultInStockFilter();
    }
  }

  disconnectedCallback() {
    this.removeEvents();
  }

  /* -------------------------------------
        DOM CACHE
  -------------------------------------- */
  cacheDom() {
    this.form = this.querySelector(this.formSelector);
    this.grid = document.querySelector(this.gridSelector);
    this.activeFilters = this.querySelector(this.activeFiltersSelector);
    this.priceButtons = this.querySelectorAll('[data-price-submit]');
  }

  /* -------------------------------------
        EVENTS
  -------------------------------------- */
  initEvents() {
    if (!this.form) return;

    this.form.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
    this.priceButtons.forEach((btn) => btn.addEventListener('click', this.onPriceSubmit));

    window.addEventListener('popstate', this.onPopState);
  }

  removeEvents() {
    if (this.form) this.form.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('popstate', this.onPopState);

    this.priceButtons.forEach((btn) => btn.removeEventListener('click', this.onPriceSubmit));
  }

  /* -------------------------------------
        FILTER CHANGE
  -------------------------------------- */
  onChange(e) {
    const input = e.target.closest('input[type="checkbox"]');
    if (!input) return;

    const url = this.buildUrl();
    this.fetchPage(url);
  }

  onClick(e) {
    const link = e.target.closest('a[href]');
    if (!link || !this.contains(link)) return;

    e.preventDefault();
    this.fetchPage(link.href);
  }

  onPriceSubmit(e) {
    e.preventDefault();
    const url = this.buildUrl();
    this.fetchPage(url);
  }

  onPopState() {
    this.fetchPage(window.location.href, false);
  }

  /* -------------------------------------
        URL BUILDER
  -------------------------------------- */
  buildUrl() {
    const current = new URL(window.location.href);
    const base = new URL(window.location.origin + window.location.pathname);

    // preserve non-filter params
    current.searchParams.forEach((v, k) => {
      if (!k.startsWith('filter.')) base.searchParams.append(k, v);
    });

    // apply checked filters
    this.form.querySelectorAll('input[type="checkbox"]:checked')
      .forEach((chk) => {
        const param = chk.dataset.param;
        const value = chk.dataset.taxonomyId || chk.dataset.value;
        if (param && value) base.searchParams.append(param, value);
      });

    // price
    const min = this.form.querySelector('input[name*=".price.gte"]');
    const max = this.form.querySelector('input[name*=".price.lte"]');

    if (min && min.value) base.searchParams.set(min.name, min.value);
    if (max && max.value) base.searchParams.set(max.name, max.value);

    return base.toString();
  }

  updateFilterCounter() {
  const counterEl = document.querySelector("#activeFiltersCount");
  const filterCountEl = document.querySelector("#filterCount");



  if (!counterEl || !filterCountEl) return;



  const count = counterEl.dataset.activeCount || "0";
  filterCountEl.textContent = `(${count})`;

    console.log(count)
}


  /* -------------------------------------
        FETCH + RENDER
  -------------------------------------- */
  async fetchPage(url, pushState = true) {
    const loader = document.querySelector('collection-loader');
    loader?.show("מציג תוצאות...");

    this.abortController?.abort();
    this.abortController = new AbortController();

    try {
      const res = await fetch(url, {
        signal: this.abortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // update grid
      const newGrid = doc.querySelector(this.gridSelector);
      if (newGrid && this.grid) this.grid.innerHTML = newGrid.innerHTML;

      const infinity = document.querySelector('infinity-products');
      infinity?.refresh?.();

      // update active filters
      const newActive = doc.querySelector(this.activeFiltersSelector);
      if (newActive && this.activeFilters) {
        this.activeFilters.innerHTML = newActive.innerHTML;
      }


      // update form w/ minimal rebind
      const newForm = doc.querySelector(this.formSelector);
      if (newForm && this.form) {
        this.form.innerHTML = newForm.innerHTML;
        this.priceButtons = this.querySelectorAll('[data-price-submit]');
        this.priceButtons.forEach((btn) => btn.addEventListener('click', this.onPriceSubmit));
      }

      if (pushState) history.pushState({}, '', url);
      this.dispatchEvent(new CustomEvent("filters-applied", { bubbles: true }));

    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('[CollectionFilters]', err);
        window.location.href = url;
      }
    } finally {
      loader?.hide?.();
      this.updateFilterCounter();
    }
  }

  /* -------------------------------------
        DEFAULT IN STOCK
  -------------------------------------- */
  applyDefaultInStockFilter() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('filter.v.availability')) return;

    url.searchParams.set('filter.v.availability', '1');
    this.fetchPage(url.toString(), true);
  }
}

customElements.define('collection-filters', CollectionFilters);
